import { useMemo } from 'react';
import { useGameStore } from '../GameStoreContext.ts';
import { usePlayerValidators } from './usePlayerValidators.ts';
import { MechanicValidatorKnightActions } from '@colonist/game-mechanic-validators';
import { useMapValidator } from './useMapValidator.ts';
export const useMechanicValidatorKnightActions = ()=>{
    const { playerValidators } = usePlayerValidators();
    const mapValidator = useMapValidator();
    const mechanicKnightState = useGameStore((state)=>state.gameState.mechanicKnightState);
    const mechanicRobberState = useGameStore((state)=>state.gameState.mechanicRobberState);
    const mechanicPirateState = useGameStore((state)=>state.gameState.mechanicPirateState);
    return useMemo(()=>{
        if (!mechanicKnightState) return undefined;
        return new MechanicValidatorKnightActions(playerValidators, mapValidator, mechanicKnightState, mechanicRobberState, mechanicPirateState);
    }, [
        playerValidators,
        mapValidator,
        mechanicKnightState,
        mechanicRobberState,
        mechanicPirateState
    ]);
};
